"use client";

import { useState, useEffect } from "react";
import { getFCMToken } from "./firebase";

/**
 * React hook to get FCM device token
 * Automatically requests token on mount and handles permission requests
 * @returns Object containing token, loading state, and error
 */
export const useFCMToken = () => {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        setLoading(true);
        const fcmToken = await getFCMToken();
        setToken(fcmToken);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to get FCM token"));
        console.error("Error fetching FCM token:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchToken();
  }, []);

  return { token, loading, error };
};
